import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { toRem, theme } from '@marriott/mi-ui-library-shop';
import { baseVariables } from '@marriott/mi-ui-library';

export const StyledAllFilterContainer = styled.div`
  ${rtl`
  .all-filters {
    padding-right: ${toRem(10)};
  }
  .pop-up-footer {
    padding: ${toRem(12)} ${toRem(16)};
    @media ${baseVariables.mediaQuery.md} {
      padding: ${toRem(20)} ${toRem(30)};
    }
  }
  .ada-hide{
    display: none;
  }
  .filter-option-button.active {
    background-color: ${theme.color['close-silver']};
  }
  .filter-option-button {
    font-weight: ${theme.fonts['fontWeightRegular']};
  }
  .filter-option-button:focus {
    outline: 0px solid -webkit-focus-ring-color;
  }
  .all-filter-badge {
    height: ${toRem(20)};
    border-radius: 50%;
    background-color: ${theme.color['cod-grey']};
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    text-align: center;
    color: ${theme.color['white']};
    padding: ${toRem(5)};
    width: max-content;
    min-width: 20px;
    margin-right: 3px;
  }
  .lower-section {
    .hotel-filters-outer-component {
      margin-top: ${toRem(8)};
    }
  }
  .icon-dining-filter {
    margin: 0 ${toRem(5)} 0 0;
    top: -4px;
  }
  .filter-separator {
    margin: 24px 0 0 0;
    padding: 0;
    border-top: ${toRem(1)} solid ${theme.color['gallery']};
    border-bottom: none;
    border-left: none;
    border-right: none;
  }

  @media only ${theme.mediaQuery.allMobiles} {
    .filter-heading {
      font-size: ${toRem(16)};
    }
  }
  `}
`;
